import { RouterProvider } from 'react-router-dom';
import { router } from './router';

export function AppRoutes() {
  return <RouterProvider router={router} />;
}
